<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
			{{ $t("benefits_summary") }}
		</div>
		<div class="bt1 bc7 p4" slot="body">
			<core-benefit-summary :tree="benefitGraphs" />
		</div>
	</j-expendable-box>
</template>

<script>
import JExpendableBox from "@/components/JExpendableBox"
import CoreBenefitSummary from "@/modules/core/components/CoreBenefitSummary"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JExpendableBox, CoreBenefitSummary },

	data() {
		return {
			benefitGraphs: []
		}
	},

	computed: {
		stringifiedBenefitOptions() {
			return JSON.stringify(
				this.$store?.state?.caseManagement?.proposals
					?.find(
						proposal =>
							proposal.id === this.$store?.state?.caseManagement?.proposalId
					)
					?.basket?.find(
						offer => offer.id === this.$store?.state?.caseManagement?.offerId
					)?.benefitOptions
			)
		}
	},

	methods: {
		// Get options for this offer
		async fetchBenefitGraphs() {
			const query = gql`
				query offer(
					$caseWhere: caseWhere
					$proposalWhere: proposalWhere
					$offerWhere: offerWhere
				) {
					cases(where: $caseWhere) {
						list {
							proposals(where: $proposalWhere) {
								basket(where: $offerWhere) {
									benefitSummary {
										benefitGraphs {
											name
											...BenefitNode
											children {
												...BenefitNode
												children {
													...BenefitNode
													children {
														...BenefitNode
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
				fragment Value on scalarValue {
					booleanValue
					dateValue
					stringValue
					numberValue
				}

				fragment TreeMapValues on scalarValue {
					...Value
					arrayValue {
						...Value
						objectValue {
							key
							value {
								...Value
							}
						}
					}
					objectValue {
						key
						value {
							...Value
						}
					}
				}

				fragment BenefitNode on benefitGraph {
					name
					description
					isOptional
					isValueInput
					optionKey
					typeId
					formattedValue: value
					value: value2 {
						...TreeMapValues
					}
				}
			`

			const variables = {
				caseWhere: { id: this.$store?.state?.caseManagement?.caseId },
				proposalWhere: { id: this.$store?.state?.caseManagement?.proposalId },
				offerWhere: { id: this.$store?.state?.caseManagement?.offerId }
			}

			const res = await api({ query, variables })

			if (res?.data?.cases?.list[0]?.proposals[0]?.basket[0]?.benefitSummary) {
				this.benefitGraphs =
					res?.data?.cases?.list[0]?.proposals[0]?.basket[0]?.benefitSummary?.benefitGraphs
			} else {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: res?.errors
							? res?.errors
							: res?.data?.cases?.errors
							? res?.data?.cases?.errors
							: res?.data?.cases?.errors_2?.message
							? res?.data?.cases?.errors_2?.message
							: "Oops ! An error occured."
					}
				})
			}
		}
	},

	watch: {
		stringifiedBenefitOptions: {
			handler(n, o) {
				if (n !== o) {
					this.fetchBenefitGraphs()
				}
			}
		}
	},

	created() {
		this.fetchBenefitGraphs()
	}
}
</script>
